// extracted by mini-css-extract-plugin
export default {"container":"GradesEvolutionChart_container__Kg8dq","legend":"GradesEvolutionChart_legend__zbHZz"};